export function buildCheckoutUrl(
  checkoutBase: string,
  productId: string,
  variationId: string,
  affiliateRef?: string | null,
  couponCode?: string | null
): string {
  let url = `${checkoutBase}?add-to-cart=${productId}&variation_id=${variationId}`;
  if (affiliateRef) url += `&ref=${encodeURIComponent(affiliateRef)}`;
  if (couponCode) url += `&coupon_code=${encodeURIComponent(couponCode)}`;
  return url;
}
